import { render, staticRenderFns } from "./BulkSetPropertyModal.vue?vue&type=template&id=35d67680"
import script from "./BulkSetPropertyModal.vue?vue&type=script&lang=js"
export * from "./BulkSetPropertyModal.vue?vue&type=script&lang=js"
import style0 from "./BulkSetPropertyModal.vue?vue&type=style&index=0&id=35d67680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports